import script from "./modal_box.vue?vue&type=script&setup=true&lang=js"
export * from "./modal_box.vue?vue&type=script&setup=true&lang=js"

import "./modal_box.vue?vue&type=style&index=0&id=45d8d56d&lang=less&scoped=true"

import exportComponent from "/usr/local/jenkins/workspace/pc-web_pc-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45d8d56d"]])

export default __exports__